<template>
    <div>
        <div>
            <h2>Banca Abierta</h2>

            <a id="" href="//www.hcdrauch.com.ar/dispos/Ordenanza339-02.doc" target>Descargar Ordenanza N°339/02 "Banca Abierta" </a>

            <br>
            <br>
            <img src="@/assets/banca_abierta.jpeg" style="width: 400px;">
 
            <h4>Requisitos Minimos</h4>

            <p> A. Nombre y Apellido, tipo y número de documento, y domicilio de la persona interesada.</p> 
            <p> B.  Si la solicitud se realiza en nombre de una institución, se adjuntará la autorización por parte de ésta para ser presentada, nombre, fines y domicilio, suscripta por presidente y secretario.</p> 
            <p> C.  Una descripción escueta y precisa del tema a exponer.</p>  
            <p> D.  La manifestación expresa y firmada del compromiso de atenerse a las normativas para acceso y utilización de la Banca Abierta.</p> 
            <p> E.  En el caso de solicitudes de personas particulares se requerirá la adhesión de treinta (30) firmas para avalar la presentación.</p> 
            <p> F.  A las firmas de adhesión del apartado precedente, se deberán adjuntar los mismos datos que prevé el punto A del presente artículo.</p> 
            
            <b-button v-b-modal.modal-formulario class="btn btn-success btn_desap" style="width:350px" @click="">Descargar Formulario de Inscripción </b-button>

  
            <br>
            <br>            
        </div>

        <b-modal id="modal-formulario" 
            header-bg-variant="success"
            size="xl"
            title="Formulario de Inscripción">
            <div class="modal-body">
                <div class="row">
                    <div class="col-2 text-end mt-2 p-0">
                        <label for="titulo-buscar">Apellido y Nombre:</label>         
                    </div>
                    <div class="col-4 p-0">
                       <b-form-input id="titulo-buscar" type="text" v-model="apyno" trim ></b-form-input>
                    </div>
                    <div class="col-1 text-end mt-2 p-0">
                        <label for="titulo-buscar">DNI:</label>         
                    </div>
                    <div class="col-2 p-0">
                       <b-form-input id="" type="text" v-model="dni" trim ></b-form-input>
                    </div>                
                </div>

                <div class="row">
                    <div class="col-3 text-end mt-2 p-0">
                        <label for="titulo-buscar">Domicilio:</label>         
                    </div>
                    <div class="col-4 align-left p-0">
                       <b-form-input id="titulo-buscar" type="text" v-model="domicilio" trim ></b-form-input>
                    </div>
                    <div class="col-3 text-end mt-2 p-0">
                        <label for="titulo-buscar">En nombre de institución:</label>         
                    </div>
                    <div class="col-1 d-flex alinng-rigth mt-2 p-0">
                        <b-form-checkbox switch v-model="institucion" value="Si" unchecked-value="No" ></b-form-checkbox>   
                    </div>             
                </div>
                <div class="row text-center" :hidden="verInstitucion">
                    <h5>Institución</h5>          
                </div>  
                <div class="row" :hidden="verInstitucion">
                    <div class="col-2 text-end mt-2 p-0">
                        <label for="titulo-buscar">Nombre:</label>         
                    </div>
                    <div class="col-4 p-0">
                       <b-form-input id="" type="text" v-model="nombreInstitucion" trim ></b-form-input>
                    </div>
                    <div class="col-2 text-end mt-2 p-0">
                        <label for="titulo-buscar">Domicilio:</label>         
                    </div>
                    <div class="col-3 p-0">
                       <b-form-input id="" type="text" v-model="domicilioInstitucion" trim ></b-form-input>
                    </div> 
                </div>  
                <div class="row" :hidden="verInstitucion">                 
                    <div class="col-1 text-end mt-2 p-0">
                        <label for="">Fines:</label>         
                    </div>
                    <div class="col-10 align-left p-0">
                       <b-form-input id="" type="text" v-model="finesInstitucion" trim ></b-form-input>
                    </div>
                </div>
                <div class="row text-center">   
                    <h5>Una descripción escueta y precisa del tema a exponer</h5> 
                </div>  
                <div class="row">         
                    <b-form-textarea id="summernote" v-model="descripcion" name="editordata"></b-form-textarea>        
                </div>  
            </div>
            <template v-slot:modal-footer="{ ok }" >
                <b-button id='Boton_Alta' :hidden="mostrarBotonAlta" variant="success" @click="altaBanca()"> Descargar PDF</b-button>

                <b-button id="BotonOkAlta" variant="secondary" @click="ok()">Cancelar</b-button>

            </template>

        </b-modal>  
    <a id="link1" href="" target></a><br> 

</div>

</template>

<style>

</style>

<script>
  import { mapState, mapActions } from 'vuex';
  import { mapMutations } from 'vuex'


  export default {
    name: 'BancaAbierta', 

    computed:{
        ...mapState(['host']),
        verInstitucion(){
            return this.institucion=='Si' ? false : true
        },
        mostrarBotonAlta(){

        }


    },  
    methods:{
        imprimirPDF(dato){
            document.getElementById('link1').href=this.host+'banca_pdf.php?id='+dato;
            document.getElementById('link1').click();
        },

        altaBanca: async function (){
            document.getElementById('BotonOkAlta').click();
            try{
                let newPost={
                    opcion:'Alta',
                    apyno:this.apyno,
                    nombre:this.nombre,
                    dni:this.dni,
                    domicilio:this.domicilio,
                    institucion:this.institucion,
                    nombreInstitucion:this.nombreInstitucion,
                    domicilioInstitucion:this.domicilioInstitucion,
                    finesInstitucion:this.finesInstitucion,
                    descripcion:this.descripcion
                };
                const entradasBD = await fetch(this.host+'banca_abierta.php',{
                    method:'POST',
                    body: JSON.stringify(newPost),
                    headers:{
                    "Content-Type": "application/json"
                    }
                });
                    const datos= await entradasBD.json();
                    console.log(datos[0]);
                    this.imprimirPDF(datos[0]);
            }catch (error){
                console.log(error);
            }  
        },
     
 



       



    },
    data() {
      return {
          apyno:'',
          dni:'',
          domicilio:'',
          institucion:'Si',
          nombreInstitucion:'',
          domicilioInstitucion:'',
          finesInstitucion:'',
          descripcion:'',
      }
    }, 

  }
</script>
